// @flow
import React, { PureComponent } from 'react';
import { isEqual } from 'lodash';

import NewsHub from 'containers/hub/NewsContainer';
import TeamHub from 'containers/hub/TeamContainer';
import PartnersHub from 'containers/hub/ParnersContainer';
import NavigationHub from 'components/hub/Navigation';

import { getPublicAssets } from 'utils/assetsUtils';

import type { CardMenuElementType, PartnerType } from 'types/Settings';
import { nullPartner } from 'types/Settings';

export type StateProps = {
  partenaires: PartnerType[],
  home_bloc_boutique: boolean,
  liste_blocs_un: CardMenuElementType[],
  liste_blocs_deux: CardMenuElementType[],
  titre_liste_blocs_un: string,
  titre_liste_blocs_deux: string
};

type Props = StateProps;

class BillboardByDefault extends PureComponent<Props> {
  render() {
    const {
      home_bloc_boutique,
      liste_blocs_un,
      liste_blocs_deux,
      partenaires,
      titre_liste_blocs_un,
      titre_liste_blocs_deux
    } = this.props;

    const noPartners = isEqual(nullPartner, partenaires[0]) || partenaires.length === 0;

    return (
      <>
        <section className="container section">
          <NewsHub rowClassNames="row mb-6 mb-md-7 mb-lg-8" />
          {liste_blocs_un.length > 0 && <NavigationHub cards={liste_blocs_un} title={titre_liste_blocs_un} />}
          <TeamHub />
        </section>

        {(!noPartners || home_bloc_boutique) && (
          <section className={home_bloc_boutique ? 'section section-white has-half-bloc' : 'section section-white'}>
            <div className="container">
              {!noPartners && <PartnersHub />}
              {home_bloc_boutique && (
                <a
                  href="https://boutique.ffr.fr/"
                  className="box card card--hub-alt card--hub-ffr card--small card--xSmall"
                  title="Boutique officielle de la FFR"
                  target="__blank"
                  rel="noopener noreferrer"
                >
                  <div
                    className="card__thumbnail img-blue-dark"
                    style={{ backgroundImage: `url(${getPublicAssets('/img/banner/official-store.jpg')})` }}
                  />
                  <div className="card__body">
                    <h3 className="card__title">Boutique officielle FFR</h3>
                    <p className="card__desc ft-secondary">
                      Grâce à votre licence obtenez des réductions sur la boutique FFR.
                    </p>
                  </div>
                  <div className="card__footer">
                    <span className="btn btn--cheer">
                      <i className="icon icon-chevron-right link-icon is-dark btn-cheer is-inline" />
                      <span>Accédez à la boutique</span>
                    </span>
                  </div>
                </a>
              )}
            </div>
          </section>
        )}

        <section className="container section">
          {liste_blocs_deux.length > 0 && (
            <NavigationHub cards={liste_blocs_deux} title={titre_liste_blocs_deux} isBottomRow />
          )}
        </section>
      </>
    );
  }
}

export default BillboardByDefault;
